import { configureStore } from "@reduxjs/toolkit";
import config from "./slicers/config";

export const store = configureStore({
    reducer: {
        config: config,
    },
});
